<input type="checkbox" class="checkbox" (change)="isChecked($event)" [checked]="value" [disabled]="disabled" [id]="checkId" [formControl]="checkControl" />